import PropTypes from 'prop-types'

import { userDetailsPropType } from '../../users/prop-types'

const unknownWordTimestampsPropType = PropTypes.shape({
  updatedBy: userDetailsPropType,
  updatedAt: PropTypes.string,
  createdBy: userDetailsPropType,
  createdAt: PropTypes.string,
  curatedBy: userDetailsPropType,
  curatedAt: PropTypes.string,
  qadBy: userDetailsPropType,
  qadAt: PropTypes.string,
})

export default unknownWordTimestampsPropType
